import React from 'react';

const PayPalSync = () => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.9077 1H7.37616C4.40699 1 2 4.39924 2 7.35885V37.7921C2 40.7517 4.40699 43.151 7.37616 43.151H37.9077C40.8769 43.151 43.2839 40.7517 43.2839 37.7921V7.35885C43.2839 4.39924 40.8769 1 37.9077 1Z"
      fill="#E2EBFA"
    />
    <path
      d="M35.9077 0H5.37616C2.40699 0 0 2.39924 0 5.35885V35.7921C0 38.7517 2.40699 41.151 5.37616 41.151H35.9077C38.8769 41.151 41.2839 38.7517 41.2839 35.7921V5.35885C41.2839 2.39924 38.8769 0 35.9077 0Z"
      fill="#F7F9FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.773 13.0101C30.1195 10.7976 29.788 9.38461 28.645 8.08261H28.6435C27.433 6.70411 25.1335 6.00061 21.859 6.00061H12.895C12.1935 6.00102 11.5966 6.512 11.488 7.20511L7.59105 31.9701C7.58706 31.9924 7.59311 32.0152 7.60758 32.0326C7.62204 32.0499 7.64345 32.06 7.66605 32.0601H12.973L14.368 23.2191L14.389 23.2221C14.659 22.3401 15.475 21.7191 16.42 21.7191H19.246C25.0465 21.7191 28.5775 19.2096 29.68 13.5501C29.713 13.3701 29.7445 13.1946 29.773 13.0101ZM33.5385 20.7078C33.9225 18.7383 33.8265 17.0373 33.0885 15.7173C31.5195 22.1658 26.9115 25.4703 19.8945 25.4703H17.817L16.392 34.5003H14.115L13.8525 36.1638C13.8197 36.373 13.8799 36.5861 14.0175 36.7471C14.1551 36.908 14.3563 37.0007 14.568 37.0008H19.5825C20.1761 37.0006 20.6813 36.5686 20.7735 35.9823L20.8215 35.7273L21.7665 29.7378L21.8265 29.4078C21.9187 28.8212 22.4237 28.3887 23.0175 28.3878H23.7675C28.6245 28.3878 32.4285 26.4168 33.5385 20.7078Z"
      fill="#003087"
    />
    <path
      d="M39.0838 48.0001C44.5604 48.0001 49.0001 43.5747 49.0001 38.1157C49.0001 32.6567 44.5604 28.2313 39.0838 28.2313C33.6072 28.2313 29.1675 32.6567 29.1675 38.1157C29.1675 43.5747 33.6072 48.0001 39.0838 48.0001Z"
      fill="#00D789"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.7723 32.6776C45.3078 33.9954 46.2854 35.9423 46.2854 38.1154C46.2854 41.7249 43.5959 44.7118 40.1111 45.2122V46.3212L37.024 44.2697L40.1111 42.2183V43.1215C42.4538 42.6428 44.2273 40.5899 44.2273 38.1155C44.2273 36.3544 43.3311 34.7989 41.9704 33.8751L43.7723 32.6776ZM38.0531 29.9097L41.1403 31.9611L38.0531 34.0126V33.1393C35.7141 33.6185 33.937 35.6441 33.937 38.1155C33.937 39.8765 34.8332 41.432 36.1939 42.3558L34.392 43.5534C32.8565 42.2355 31.8789 40.2886 31.8789 38.1155C31.8789 34.5063 34.5687 31.5231 38.0531 31.0228V29.9097Z"
      fill="white"
    />
  </svg>
);

export default PayPalSync;
